import React, { useState, useEffect } from 'react';
import { Input, Button, DatePicker, Select, AutoComplete, message } from 'antd';

const { Option } = Select;

const OrderFormComponent = () => {
  // Lấy tên khách hàng từ localStorage
  const storedName = localStorage.getItem('name') || '';

  // Khởi tạo state với tên khách hàng đã lấy từ localStorage
  const [formData, setFormData] = useState({
    tenKhachHang: storedName,
    soDienThoai: '',
    email: '',
    loaiXe: '',
    trongTai: '',
    thoiGianVanChuyen: null,
    diemDi: '',
    diemDiThucTe: '',
    diemDen: '',
    diemDenThucTe: '',
    ghiChu: '',
    loaiKetNoi: '',
    diemDiOptions: [],
    diemDenOptions: [],
  });

  // Cập nhật tự động trường loaiKetNoi dựa trên điểm đi và điểm đến
  useEffect(() => {
    if (formData.diemDi === '' || formData.diemDen === '') {
      setFormData((prevData) => ({
        ...prevData,
        loaiKetNoi: '',
      }));
    } else if (formData.diemDi === formData.diemDen) {
      setFormData((prevData) => ({
        ...prevData,
        loaiKetNoi: formData.diemDi === 'Hồ Chí Minh' ? 'Nội thành' : 'Nội tỉnh',
      }));
    } else {
      const noiVungProvinces = [
        'Quảng Nam', 'Quảng Ngãi', 'Bình Định', 'Phú Yên', 'Khánh Hòa', 'Ninh Thuận', 'Bình Thuận',
        'Kon Tum', 'Gia Lai', 'Đắk Lắk', 'Đắk Nông', 'Lâm Đồng', 'Bình Phước', 'Bình Dương', 'Đồng Nai',
        'Tây Ninh', 'Bà Rịa-Vũng Tàu', 'Long An', 'Đồng Tháp', 'Tiền Giang', 'An Giang', 'Bến Tre',
        'Vĩnh Long', 'Trà Vinh', 'Hậu Giang', 'Kiên Giang', 'Sóc Trăng', 'Bạc Liêu', 'Cà Mau', 'Hồ Chí Minh', 'Cần Thơ'
      ];
      setFormData((prevData) => ({
        ...prevData,
        loaiKetNoi: noiVungProvinces.includes(formData.diemDi) && noiVungProvinces.includes(formData.diemDen)
          ? 'Nội vùng'
          : 'Bắc Nam',
      }));
    }
  }, [formData.diemDi, formData.diemDen]);

  // Hàm gọi API VietMap để lấy gợi ý địa chỉ
  const loadOptions = async (inputValue, field) => {
    if (!inputValue) return [];
    const apiKey = 'babc2659cbd0eb4a1ad8598481c3b003bc94d70196e42c41';
    const url = `https://maps.vietmap.vn/api/autocomplete/v3?apikey=${apiKey}&text=${encodeURIComponent(inputValue)}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      // Chuyển đổi dữ liệu trả về thành mảng option có cấu trúc:
      // Mỗi option có: { label: string, value: string, data: { mainValue, displayValue } }
      return data.map((item) => ({
        label: item.display,
        value: item.boundaries[2]?.name || item.display,
        data: {
          mainValue: item.boundaries[2]?.name || item.display,
          displayValue: item.display || '',
        },
      }));
    } catch (error) {
      console.error(`Lỗi khi gọi API autocomplete cho ${field}:`, error);
      return [];
    }
  };

  // Khi người dùng chọn gợi ý cho điểm đi hoặc điểm đến
  const handleSelectChange = (field, selectedOption) => {
    if (selectedOption) {
      // Nếu option có thuộc tính data, dùng nó; nếu không, dùng giá trị và label của chính option đó.
      const mainValue = selectedOption.data ? selectedOption.data.mainValue : selectedOption.value;
      const displayValue = selectedOption.data ? selectedOption.data.displayValue : selectedOption.label;
      setFormData((prev) => ({
        ...prev,
        [field]: mainValue,
        [`${field}ThucTe`]: displayValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: '',
        [`${field}ThucTe`]: '',
      }));
    }
  };

  // Cập nhật giá trị hiển thị khi người dùng gõ trên AutoComplete
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Xử lý submit form: gửi dữ liệu về backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Chuẩn bị payload để gửi, chuyển đổi thời gian thành ISO string nếu có
    const payload = {
      tenKhachHang: formData.tenKhachHang,
      soDienThoai: formData.soDienThoai,
      email: formData.email,
      loaiXe: formData.loaiXe,
      trongTai: formData.trongTai,
      thoiGianVanChuyen: formData.thoiGianVanChuyen ? formData.thoiGianVanChuyen.toISOString() : null,
      diemDi: formData.diemDi,
      diemDiThucTe: formData.diemDiThucTe,
      diemDen: formData.diemDen,
      diemDenThucTe: formData.diemDenThucTe,
      ghiChu: formData.ghiChu,
      loaiKetNoi: formData.loaiKetNoi,
    };

    try {
      const response = await fetch('/api/orders', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      if (!response.ok) {
        throw new Error('Error submitting order');
      }
      message.success('Đặt đơn hàng thành công!');
      // Reset lại form, với tên khách hàng vẫn lấy từ localStorage
      setFormData({
        tenKhachHang: localStorage.getItem('name') || '',
        soDienThoai: '',
        email: '',
        loaiXe: '',
        trongTai: '',
        thoiGianVanChuyen: null,
        diemDi: '',
        diemDiThucTe: '',
        diemDen: '',
        diemDenThucTe: '',
        ghiChu: '',
        loaiKetNoi: '',
        diemDiOptions: [],
        diemDenOptions: [],
      });
    } catch (error) {
      console.error(error);
      message.error('Có lỗi xảy ra khi đặt đơn hàng');
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
      {/* Tên khách hàng: Lấy từ localStorage và không cho chỉnh sửa */}
      <div style={{ marginBottom: '16px' }}>
        <label>Tên khách hàng:</label>
        <Input
          name="tenKhachHang"
          placeholder="Tên khách hàng"
          value={formData.tenKhachHang}
          disabled
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label>Số điện thoại:</label>
        <Input
          name="soDienThoai"
          placeholder="Nhập số điện thoại"
          value={formData.soDienThoai}
          onChange={(e) => setFormData({ ...formData, soDienThoai: e.target.value })}
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label>Email:</label>
        <Input
          name="email"
          placeholder="Nhập email (nếu có)"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label>Loại xe:</label>
        <Select
          placeholder="Chọn loại xe"
          value={formData.loaiXe}
          onChange={(value) => setFormData({ ...formData, loaiXe: value })}
          style={{ width: '100%' }}
        >
          <Option value="Khô">Khô</Option>
          <Option value="Lạnh">Lạnh</Option>
        </Select>
      </div>
      {/* Trọng tải: Sử dụng Select với các giá trị có sẵn */}
      <div style={{ marginBottom: '16px' }}>
        <label>Trọng tải (kg):</label>
        <Select
          placeholder="Chọn trọng tải"
          value={formData.trongTai}
          onChange={(value) => setFormData({ ...formData, trongTai: value })}
          style={{ width: '100%' }}
        >
          <Option value="830">830</Option>
          <Option value="900">900</Option>
          <Option value="1250">1250</Option>
          <Option value="1650">1650</Option>
          <Option value="1900">1900</Option>
          <Option value="1995">1995</Option>
          <Option value="2500">2500</Option>
          <Option value="3500">3500</Option>
          <Option value="3900">3900</Option>
          <Option value="4500">4500</Option>
          <Option value="4995">4995</Option>
          <Option value="5100">5100</Option>
          <Option value="5300">5300</Option>
          <Option value="5400">5400</Option>
          <Option value="6500">6500</Option>
          <Option value="6600">6600</Option>
          <Option value="8000">8000</Option>
          <Option value="13000">13000</Option>
          <Option value="17900">17900</Option>
          <Option value="Container">Container</Option>
        </Select>
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label>Thời gian vận chuyển:</label>
        <DatePicker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          style={{ width: '100%' }}
          onChange={(value) => setFormData({ ...formData, thoiGianVanChuyen: value })}
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label>Điểm Đi:</label>
        <AutoComplete
          style={{ width: '100%' }}
          placeholder="Nhập địa chỉ điểm đón hàng"
          value={formData.diemDiThucTe}
          options={formData.diemDiOptions}
          onSearch={async (value) => {
            const options = await loadOptions(value, 'diemDi');
            setFormData((prev) => ({ ...prev, diemDiOptions: options }));
          }}
          onChange={(value) => handleInputChange('diemDiThucTe', value)}
          onSelect={(value, option) => handleSelectChange('diemDi', option)}
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label>Điểm Đến:</label>
        <AutoComplete
          style={{ width: '100%' }}
          placeholder="Nhập địa chỉ giao hàng"
          value={formData.diemDenThucTe}
          options={formData.diemDenOptions}
          onSearch={async (value) => {
            const options = await loadOptions(value, 'diemDen');
            setFormData((prev) => ({ ...prev, diemDenOptions: options }));
          }}
          onChange={(value) => handleInputChange('diemDenThucTe', value)}
          onSelect={(value, option) => handleSelectChange('diemDen', option)}
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label>Ghi chú:</label>
        <Input.TextArea
          name="ghiChu"
          placeholder="Nhập ghi chú (nếu có)"
          value={formData.ghiChu}
          onChange={(e) => setFormData({ ...formData, ghiChu: e.target.value })}
          rows={4}
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label>Loại kết nối (tự động):</label>
        <Input value={formData.loaiKetNoi} disabled />
      </div>
      <div>
        <Button type="primary" htmlType="submit">
          Đặt Đơn Hàng
        </Button>
      </div>
    </form>
  );
};

export default OrderFormComponent;
